import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-04_01",
  version: "2026.06.04",
  date: "4 Jun 2026",
  sinceCommit: "fadb196",
  gameplay: [
    { text: "New PvE co-op mode: fight Angel and Titan bosses in a gauntlet (CC immunities, phased abilities, add summons)." },
    { text: "Over the void: movement and turning slowed (55% move accel, 50% turn rate); void drain gentler (~5.8s to drain full HP at ramp)." },
    { text: "You must turn to face your aim direction before casting — no instant snap-aim." },
  ],
  skills: [
    {
      spellId: "sanctuary",
      changes: [{
        text: "New spell (slot 2, replaces Scourge): channel 1.5s, then release a holy pulse that mends nearby allies and yourself (52 heal).",
      }],
    },
    {
      spellId: "chainmend",
      changes: [{
        text: "New spell (slot 3): mends the nearest injured ally, then jumps to up to 2 more teammates (38 heal, 0.80 falloff per hop).",
      }],
    },
    {
      spellId: "bloompod",
      changes: [{
        text: "New spell (slot 4): plant a swelling spore; after 2.2s it bursts — 50 heal to allies and 28 damage to foes in a 120-radius blast. Allies see the radius while it grows.",
      }],
    },
  ],
};
